<template src="./Edit.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },

    created() {
        this.$store
            .dispatch("suppliers/getForEdit", this.itemId)
            .then((res) => {
                this.vm = res;
            }).catch(() => { });
    },
    computed: {
     
    },
    data() {
        return {
            vm: {
                supplierName: null,
                address: null,
                phoneNo: null,
            },
        };
    },
    methods: {
        confirm() {
            this.$store
                .dispatch("suppliers/edit", { id: this.itemId, payload: this.vm })
                .then(() => {
                    this.back();
                })
                .catch(() => { });
        },
        back() {

            this.$emit("back");
        },
    },
};
</script>